<header class="fixed top-0 left-0 right-0 bg-white border-b border-gray-300 z-50">
  <div class="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">
    <!-- Logo -->
    <div class="flex items-center">
      <div class="flex flex-col items-center">
        <a href="/" class="inline-block">
          <img 
            [src]="logoUrl" 
            alt="Logo" 
            class="h-12 w-auto"
          />
        </a>
        @if (isNonProd) {
          <span class="mt-1 px-2 py-0.5 text-[10px] font-bold uppercase rounded-full"
            [class]="envName === 'development' ? 'bg-yellow-400 text-yellow-900' : 'bg-blue-500 text-white'">
            {{ envName === 'development' ? 'DEV' : 'TEST' }}
          </span>
        }
      </div>
    </div>

    <!-- Navigation Bar -->
    <nav class="flex-1 mx-8">
      <div class="px-4 py-3 text-center text-gray-600">
        <!-- NAV BAR -->
      </div>
    </nav>

    <!-- Login and Cart -->
    <div class="flex items-center gap-6">
      <!-- Account Menu -->
      <div class="relative">
        <button 
          (click)="toggleAccountMenu()"
          class="text-gray-700 hover:text-gray-900 transition font-bold text-sm flex items-center gap-1"
        >
          @if (authService.currentUser()) {
            <span>{{ authService.currentUser()?.firstname }}</span>
          } @else {
            <span>Mi Cuenta</span>
          }
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
          </svg>
        </button>

        <!-- Dropdown Menu -->
        @if (isAccountMenuOpen) {
          <!-- Backdrop para cerrar al hacer click fuera -->
          <div 
            class="fixed inset-0 z-40" 
            (click)="closeAccountMenu()"
          ></div>
          
          <div class="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
            @if (authService.currentUser()) {
              <!-- Usuario autenticado -->
              <div class="px-4 py-2 border-b border-gray-100">
                <p class="text-sm font-semibold text-gray-900">{{ authService.currentUser()?.firstname }} {{ authService.currentUser()?.lastname }}</p>
                <p class="text-xs text-gray-500">{{ authService.currentUser()?.email }}</p>
              </div>
              <button 
                (click)="goToProfile()"
                class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition"
              >
                Mi Perfil
              </button>
              <button 
                (click)="logout()"
                class="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition"
              >
                Cerrar Sesión
              </button>
            } @else {
              <!-- Usuario no autenticado -->
              <button 
                (click)="goToLogin()"
                class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition"
              >
                Iniciar Sesión
              </button>
            }
          </div>
        }
      </div>
      
      <!-- boton cart-->
      <div class="flex items-center gap-2">
        @if (timeRemaining() && cartCount() > 0) {
          <span class="text-xs font-mono font-semibold text-[#e8343f] bg-red-50 px-2 py-1 rounded">
            {{ timeRemaining() }}
          </span>
        }
        <button 
          (click)="openCart()"
          class="relative hover:opacity-80 transition"
          aria-label="Abrir carrito"
        >
          <svg class="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"></path>
          </svg>
          @if (cartCount() > 0) {
            <span class="absolute -top-2 -right-2 bg-[#e8343f] text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
              {{ cartCount() }}
            </span>
          }
        </button>
      </div>
    </div>
  </div>
</header>

<!-- Spacer to prevent content from going under fixed header -->
<div class="h-[88px]"></div>

<!-- Cart Sidebar Offcanvas -->
@if (isCartOpen) {
  <!-- Backdrop: solo visible en móvil -->
  <div 
    class="fixed inset-0 bg-black/40 z-40 md:hidden"
    (click)="closeCart()"
  ></div>
  <!-- Offcanvas Panel -->
  <div 
    class="fixed top-0 right-0 h-full w-3/4 md:w-96 bg-white shadow-2xl md:shadow-lg transform transition-transform duration-300 flex flex-col z-50"
  >
      <!-- Header -->
      <div class="flex items-center justify-between p-4 border-b border-gray-200">
        <div class="flex-1">
          <h2 class="text-xl font-bold text-gray-900">Carrito de Compras</h2>
          @if (timeRemaining() && cartCount() > 0) {
            <div class="flex items-center gap-2 mt-1">
              <svg class="w-4 h-4 text-[#e8343f]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              <span class="text-sm font-mono font-semibold text-[#e8343f]">
                Expira en {{ timeRemaining() }}
              </span>
            </div>
          }
        </div>
        <button 
          (click)="closeCart()"
          class="p-2 hover:bg-gray-100 rounded-full transition-colors"
          aria-label="Cerrar carrito"
        >
          <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>

      <!-- Content -->
      <div class="flex-1 overflow-y-auto p-4">
        @if (isLoadingCart()) {
          <!-- Loading State -->
          <div class="flex items-center justify-center h-full">
            <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-[#e8343f]"></div>
          </div>
        } @else if (!cartData() || !cartData()?.tickets?.length) {
          <!-- Empty Cart Message -->
          <div class="flex flex-col items-center justify-center h-full text-center">
            <svg class="w-20 h-20 text-gray-300 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
            </svg>
            <p class="text-gray-600 font-medium mb-2">Tu carrito está vacío</p>
            <p class="text-sm text-gray-500">Agrega tickets para comenzar tu compra</p>
          </div>
        } @else {
          <!-- Cart Items -->
          <div class="space-y-4">
            <!-- Event Info -->
            @if (cartData()?.evento) {
              <div class="bg-gray-50 rounded-lg p-3 border border-gray-200">
                <div class="flex gap-3">
                  @if ( cartData()?.evento?.imagenes?.cuadrada) {
                    <img 
                      [src]="cartData()?.evento?.imagenes?.cuadrada" 
                      [alt]="cartData()?.evento?.nombre"
                      class="w-16 h-16 rounded object-cover"
                    />
                  }
                  <div class="flex-1 min-w-0">
                    <h3 class="font-semibold text-sm text-gray-900 truncate">{{ cartData()?.evento?.nombre }}</h3>
                    <p class="text-xs text-gray-600 mt-1">{{ cartData()?.evento?.lugar  }}</p>
                  </div>
                </div>
              </div>
            }

            <!-- Tickets List -->
            <div class="space-y-3">
              <h3 class="font-semibold text-sm text-gray-700">Tickets ({{ cartData()?.ticketCount || cartData()?.tickets?.length }})</h3>
              @for (ticket of cartData()?.ticketsDetailed; track ticket.ticketid) {
                <div class="bg-white rounded-lg p-3 border border-gray-200">
                  <div class="flex justify-between items-start gap-3">
                    <div class="flex-1">
                      @if (ticket.tipoticket?.subevento?.nombre) {
                        <p class="text-sm font-semibold text-gray-900">{{ ticket.tipoticket?.subevento?.nombre }}</p>
                        <p class="text-xs text-gray-600 mt-0.5">{{ ticket.tipoticket?.nombre_localidad }}</p>
                      } @else {
                        <p class="text-sm font-semibold text-gray-900">
                          {{ ticket.tipoticket?.nombre_localidad || ticket.precioTipoTicket?.nombre_precio || 'Ticket' }}
                        </p>
                      }
                      @if (ticket.tipoticket?.funcion?.fecha) {
                        <p class="text-xs text-gray-500 mt-0.5">
                          📅 {{ ticket.tipoticket?.funcion?.fecha }}@if (ticket.tipoticket?.funcion?.hora) { · 🕐 {{ ticket.tipoticket?.funcion?.hora }}}
                        </p>
                      }
                      <p class="text-xs text-gray-600 mt-0.5">
                        {{ ticket.precioTipoTicket?.nombre_precio }}
                      </p>
                      <p class="text-xs text-gray-400 mt-0.5">Asiento #{{ ticket.secuencial }}</p>
                    </div>
                    <div class="text-right flex items-start gap-2">
                      <div>
                        <p class="text-sm font-bold text-gray-900">${{ ticket.precio_pagado.toFixed(2) }}</p>
                      </div>
                      <button
                        (click)="removeTicket(ticket.ticketid)"
                        class="p-1 hover:bg-red-50 rounded transition-colors"
                        title="Eliminar ticket"
                      >
                        <svg class="w-4 h-4 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              }
            </div>

            <!-- Total -->
            <div class="border-t border-gray-200 pt-4 mt-4">
              <div class="flex justify-between items-center mb-2">
                <span class="text-sm text-gray-600">Subtotal</span>
                <span class="text-sm font-medium text-gray-900">${{ getTotalPrice().toFixed(2) }}</span>
              </div>
              <div class="flex justify-between items-center">
                <span class="text-base font-semibold text-gray-900">Total</span>
                <span class="text-lg font-bold text-gray-900">${{ getTotalPrice().toFixed(2) }} USD</span>
              </div>
            </div>
          </div>
        }
      </div>

      <!-- Footer (for future checkout button) -->
      <div class="p-4 border-t border-gray-200">
        @if (cartData() && cartData()?.tickets?.length) {
          <button 
            (click)="proceedToCheckout()"
            class="w-full bg-[#e8343f] text-white py-3 rounded-lg font-semibold hover:bg-red-700 transition-colors"
          >
            Continuar con la compra
          </button>
        } @else {
          <button 
            class="w-full bg-gray-300 text-gray-500 py-3 rounded-lg font-semibold cursor-not-allowed"
            disabled
          >
            Continuar con la compra
          </button>
        }
      </div>
    </div>
}

